// extracted by mini-css-extract-plugin
module.exports = {"listWrapper":"List_listWrapper__2Zh58","ulContainer":"List_ulContainer__3Ij5O","listItem":"List_listItem__23rX1"};